import { bcrypt, bcryptVerify } from "hash-wasm";

async function hashPassword(password) {
  const salt = crypto.getRandomValues(new Uint8Array(16));

  const hash = await bcrypt({
    password,
    salt,
    costFactor: 10,
    outputType: "encoded",
  });

  return hash;
}

export const generateToken = async (key, value) => {
  const hash = await hashPassword(value);

  localStorage.setItem(key, hash);
};

export const compareToken = async (key, value) => {
  let isSame;

  const prevToken = localStorage.getItem(key);

  //compare value (sessionId) with stored token
  // if there is no token saved, 2FA will be required
  if (!!prevToken) {
    isSame = await bcryptVerify({
      password: `${value}`,
      hash: prevToken,
    });
  }

  return isSame;
};
